import React, { useCallback } from 'react';
import { Header } from '../components/Header';
import { Divider } from '../components/Divider';
import { Hero } from '../components/Hero';
import { PainSection } from '../components/PainSection';
import { TransformationSection } from '../components/TransformationSection';
import { WhatIsSection } from '../components/WhatIsSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { IncludesSection } from '../components/IncludesSection';
import { PriceSection } from '../components/PriceSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
import { Footer } from '../components/Footer';
import { OfferToast } from '../components/OfferToast';
export function Landing() {
  const scrollToPrice = useCallback(() => {
    document.getElementById('precio')?.scrollIntoView({
      behavior: 'smooth'
    });
  }, []);
  return <div className="w-full bg-crema font-sans text-tinta" data-id="element-274" data-mp="3tgbf7m9wisqo">
      <Header onCTA={scrollToPrice} data-id="element-275" data-mp="3tes03yzzenqh" />
      <main data-id="element-276" data-mp="3peq8kinynaox">
        <Hero onCTA={scrollToPrice} data-id="element-277" data-mp="3pegeaivvuhdf" />
        <Divider data-id="element-278" data-mp="3pfj6qv8usrvg" />
        <PainSection data-id="element-279" data-mp="3pezyk6909hum" />
        <Divider data-id="element-280" data-mp="3kfn16rkicsds" />
        <TransformationSection data-id="element-281" data-mp="3kg6kablw9mte" />
        <Divider data-id="element-282" data-mp="3kgyfhlbkxij5" />
        <WhatIsSection data-id="element-283" data-mp="3khhm45vs4khv" />
        <Divider data-id="element-284" data-mp="l0ibk80o5br1" />
        <HowItWorksSection data-id="element-285" data-mp="l11i6skvcdpr" />
        <Divider data-id="element-286" data-mp="kz89l7qp3jf4" />
        <IncludesSection data-id="element-287" data-mp="kzqestvc57z6" />
        <Divider data-id="element-288" data-mp="l2cop05p7zkk" />
        <PriceSection onCTA={scrollToPrice} data-id="element-289" data-mp="gz6fbjnahs9v" />
        <Divider data-id="element-290" data-mp="gzg8th7jmhkb" />
        <TestimonialsSection data-id="element-291" data-mp="h113r7xrs2ip" />
        <GuaranteeSection data-id="element-292" data-mp="c7y9syp2yr1z" />
        <Divider data-id="element-293" data-mp="c76e7nvhgtbp" />
        <FAQSection data-id="element-294" data-mp="c6n60yvmxjav" />
        <FinalCTASection onCTA={scrollToPrice} data-id="element-295" data-mp="c63ovkdt6yxw" />
      </main>
      <Footer data-id="element-296" data-mp="78bv0ktlt2r2" />
      <OfferToast data-id="element-297" data-mp="78lju52wx3v6" />
    </div>;
}